import {MIP_DEBUG_COLORS} from "@cm/three-texture-streaming"
import type {Vector2Like} from "@cm/math"

export function createDebugTileImage(width: number, height: number, mipLevel: number, tileIndex: Vector2Like): ImageBitmap {
    const gradient = false
    const [r, g, b] = MIP_DEBUG_COLORS[Math.min(mipLevel, MIP_DEBUG_COLORS.length - 1)]
    const canvas = new OffscreenCanvas(width, height)
    const ctx = canvas.getContext("2d")!
    if (gradient) {
        const grad = ctx.createLinearGradient(0, 0, width, height)
        grad.addColorStop(0, "rgb(0,0,0)")
        grad.addColorStop(1, `rgb(${r},${g},${b})`)
        ctx.fillStyle = grad
    } else {
        const isColored = (tileIndex.x + tileIndex.y) % 2 === 0
        ctx.fillStyle = isColored ? `rgb(${r},${g},${b})` : "rgb(0,0,0)"
    }
    ctx.fillRect(0, 0, width, height)
    return canvas.transferToImageBitmap()
}
